import { render, staticRenderFns } from "./settingContentEditor.vue?vue&type=template&id=b6610efa&scoped=true"
import script from "./settingContentEditor.vue?vue&type=script&lang=js"
export * from "./settingContentEditor.vue?vue&type=script&lang=js"
import style0 from "./settingContentEditor.vue?vue&type=style&index=0&id=b6610efa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6610efa",
  null
  
)

export default component.exports